import React, { PropsWithChildren, useContext, useState, useEffect } from 'react';
import { Store, StorageType } from '@nakedplatform/support';

const ProspectContext = React.createContext<ContextProps>({});

/**
 * Renders the prospect provider
 *
 * @param props - Prospect provider props
 */
export function ProspectProvider(props: Props) {
  const { children } = props;
  const [prospectCount, setProspectCount] = useState<string>(undefined);

  useEffect(() => {
    if (Store.hasStorage) {
      const LocalStorage = Store.getStorage(StorageType.LocalStorage);
      const guestBasketHash = LocalStorage.getItem('guestBasketHash');

      if (guestBasketHash) {
        const count = LocalStorage.getItem('prospectCount');

        if (count) {
          setProspectCount(count);
        }
      }
    }
  }, []);

  return (
    <ProspectContext.Provider value={{ prospectCount, setProspectCount }}>
      {children}
    </ProspectContext.Provider>
  );
}
type Props = PropsWithChildren<Record<string, unknown>>;
interface ContextProps {
  prospectCount?: string;
  setProspectCount?(count: string): void;
}

/**
 * Hook for interacting with prospect
 */
export function useProspect() {
  const { prospectCount, setProspectCount } = useContext(ProspectContext);

  return { prospectCount, setProspectCount };
}
